import "./form-reward-event.scss";

import { RewardEventFormSchema } from "@factory/form/form.rule";
import { useQyGetLevel } from "@factory/query/level.query";
import { LabelValue } from "@shared/models/label-value.interface";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputTextareaControl from "@shared/ui/hook-form/input-textarea-control/input-textarea-control";
import { InputSwitch } from "primereact/inputswitch";
import { useState } from "react";
import { useFormContext } from "react-hook-form";

import { appFeature } from "../../../app.feature";

type InputFormSchema = RewardEventFormSchema;
export interface FormRewardEventProps {
  hasLevel: boolean;
  allLevelChange?: (allLevel: boolean) => void;
}
export function FormRewardEvent({
  hasLevel,
  allLevelChange,
}: FormRewardEventProps) {
  const { pointsText, stampsText } = appFeature.config.label;
  const { control } = useFormContext<RewardEventFormSchema>();
  const [isAllLevel, setIsAllLevel] = useState(!hasLevel);
  const { data: response } = useQyGetLevel("", 9999);
  const levelOption = LabelValue.MapArray(
    response?.data || [],
    (item) => item.name,
    (item) => item.code
  );

  return (
    <div id="FormRewardEvent" className="reward-event">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputTextareaControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <div className="flex items-center justify-start gap-2 mb-4">
        <InputSwitch
          checked={isAllLevel}
          onChange={(e) => {
            setIsAllLevel(e.value);

            if (allLevelChange) {
              allLevelChange(e.value);
            }
          }}
        />
        <span>For All Level</span>
      </div>
      {!isAllLevel ? (
        <DropdownControl<InputFormSchema>
          control={control}
          name="level"
          label="Level"
          className="w-full md:w-3/4"
          containerClassName="pb-2"
          options={levelOption}
          placeholder="Enter level"
        />
      ) : null}
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isPoints"
        label={`Is ${pointsText}`}
        containerClassName="pb-2"
      />
      <CheckboxControl<InputFormSchema>
        control={control}
        name="isStamp"
        label={`Is ${stampsText}`}
        containerClassName="pb-2"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="denominationPoints"
        label={`Denomination ${pointsText}`}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder={`Enter Denomination ${pointsText}`}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="points"
        label={pointsText}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder={`Enter ${pointsText}`}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="denominationStamp"
        label={`Denomination ${stampsText}`}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder={`Enter Denomination ${stampsText}`}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="stamp"
        label={stampsText}
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder={`Enter ${stampsText}`}
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="startDate"
        label="Start Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="endDate"
        label="End Date"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
      />
    </div>
  );
}

export default FormRewardEvent;
